export class AppConstants {

  public static readonly statusPollingInterval = 5000;
  public static readonly memberPollingInterval = 60000;
  public static readonly chatPollingInterval = 3000;
  public static readonly chatRetryAttempts = 3;
  public static readonly threeMinutesSec = 180;
  public static readonly chatRetryDelay = 5000;
  public static readonly productListMaximumLength: number = 2;

}
